export default function CompanyResults() {
  const results = [
    { icon: 'ri-emotion-happy-line', title: 'Рост удовлетворённости клиентов', desc: 'Сотрудники обучаются выявлять ожидания, грамотно коммуницировать и решать проблемы. Клиенты чувствуют заботу и ценят это.' },
    { icon: 'ri-repeat-line', title: 'Рост повторных обращений', desc: 'Довольный клиент возвращается. Качественная коммуникация увеличивает частоту и объём повторных покупок.' },
    { icon: 'ri-thumb-up-line', title: 'Рост рекомендаций', desc: 'Клиенты, получившие отличный опыт, рекомендуют компанию. Сарафанное радио — самый дешёвый и эффективный канал привлечения.' },
    { icon: 'ri-money-dollar-circle-line', title: 'Рост среднего чека', desc: 'Умение выявлять потребности и предлагать ценность увеличивает средний чек без агрессивных продаж.' },
    { icon: 'ri-shield-check-line', title: 'Уменьшение конфликтов', desc: 'Сотрудники получают инструменты для профилактики и управления конфликтами. Снижается нагрузка на руководителей.' },
    { icon: 'ri-file-check-line', title: 'Единые стандарты общения', desc: 'Каждый клиент получает стабильно высокий уровень сервиса. Нет разницы, с кем из сотрудников он общается.' },
    { icon: 'ri-hand-heart-line', title: 'Рост доверия', desc: 'Последовательная, честная и профессиональная коммуникация укрепляет доверие клиентов к компании.' },
    { icon: 'ri-star-line', title: 'Сильный клиентский опыт', desc: 'Формируется устойчивый позитивный клиентский опыт — конкурентное преимущество, которое сложно скопировать.' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Рост NPS', desc: 'Индекс потребительской лояльности растёт, что напрямую коррелирует с ростом выручки и прибыли бизнеса.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-bar-chart-grouped-line"></i>
            Бизнес-результаты
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие результаты получает компания
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Системное обучение работе с клиентами приносит измеримые бизнес-результаты: от роста лояльности до прямого увеличения прибыли.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {results.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors group">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}